import { toast } from 'sonner';

/**
 * Prompt for image alt text. Returns null if the user cancels the insert/edit.
 */
export function promptImageAltText(initial = '') {
  const alt = window.prompt(
    'Alt text for accessibility:\n\nDescribe what the image conveys. Leave empty only if the image is purely decorative.',
    initial ?? '',
  );
  if (alt === null) return null;
  return alt.trim();
}

export function insertImageWithAlt(editor, src, alt) {
  if (!editor || !src) return;
  editor.chain().focus().setImage({ src, alt: alt ?? '' }).run();
}

/** Prompt for alt, then insert. Returns false if cancelled. */
export function promptAndInsertImage(editor, src) {
  const alt = promptImageAltText();
  if (alt === null) return false;
  insertImageWithAlt(editor, src, alt);
  return true;
}

/** Toolbar flow: URL → upload → alt prompt → insert. */
export async function addImageFromUrl(editor, uploadFromUrl) {
  const url = window.prompt('Image URL (will be downloaded and stored locally):');
  if (!url || !url.trim()) return;
  try {
    const localUrl = await uploadFromUrl(url.trim());
    if (localUrl) promptAndInsertImage(editor, localUrl);
  } catch (e) {
    toast.error(e.response?.data?.detail || 'Failed to add image');
  }
}

/** TipTap handlePaste: upload clipboard image, then prompt for alt. */
export function createImagePasteHandler(uploadFile, getEditor) {
  return (view, event) => {
    const items = event.clipboardData?.items;
    if (!items) return false;
    for (const item of items) {
      if (item.type.startsWith('image/')) {
        event.preventDefault();
        const file = item.getAsFile();
        if (!file) return true;
        uploadFile(file)
          .then((src) => {
            const editor = typeof getEditor === 'function' ? getEditor() : getEditor;
            if (editor) promptAndInsertImage(editor, src);
          })
          .catch(() => toast.error('Failed to upload pasted image'));
        return true;
      }
    }
    return false;
  };
}
